import { useTranslation } from 'react-i18next';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import DownloadDocumentButton from '../../components/buttons/DownloadDocumentButton';
import GoBackButton from '../../components/buttons/GoBackButton';
import { SECTIONS_AND_PACAGES_UPLOAD_STRUCTURE_DOCUMENT } from '../../config/constants';
import { PathsLayouts } from '../../config/routes';
import PeriodView from '../../packagesMaintainer/PeriodView';

const sectionAttributesStructureFileName = SECTIONS_AND_PACAGES_UPLOAD_STRUCTURE_DOCUMENT;
const sectionAttributesStructureFileURL = `/tenant/${SECTIONS_AND_PACAGES_UPLOAD_STRUCTURE_DOCUMENT}`;

const SectionsAndPackagesView = (): JSX.Element => {
  const { t } = useTranslation();
  const { periodId } = useParams<{ periodId?: string }>();
  const history = useHistory();

  function goBack() {
    history.push(PathsLayouts.packagesMaintainer);
  }

  if (!periodId || isNaN(parseInt(periodId))) {
    return <Redirect to={PathsLayouts.packagesMaintainer} />;
  }

  return (
    <div className="g-table-container mt-2 pb-4 pt-4 mx-3">
      <Row className="mb-5">
        <Col lg={7} xl={7}>
          <div className="mb-4">
            <GoBackButton onClick={goBack} />
          </div>
          <div className="fs-16">{t('packagesMaintainer.detailTitleDesc')}</div>
        </Col>
        <Col lg={5} xl={5}>
          <DownloadDocumentButton
            buttonText={t(`packagesMaintainer.downloadExcelLayout`)}
            userFileName={sectionAttributesStructureFileName}
            fileURL={sectionAttributesStructureFileURL}
            outlined
          />
        </Col>
      </Row>
      <PeriodView periodId={parseInt(periodId)} />
    </div>
  );
};

export default SectionsAndPackagesView;
